interface OverdueTask {
  status: string;
  dueDate?: string | null;
  scheduledDate?: string | null;
}

/**
 * Una tarea está vencida si su fecha límite (día calendario) es anterior a
 * "hoy" en la zona horaria del rancho. `today` es YYYY-MM-DD (ver useRanchoToday);
 * se compara por texto para no depender de la zona del navegador ni de UTC.
 */
export function isTaskOverdue(task: OverdueTask, today: string): boolean {
  if (task.status === 'COMPLETED' || task.status === 'CANCELLED') return false;
  const due = task.dueDate ?? task.scheduledDate;
  if (!due) return false;
  const day = String(due).slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return false;
  return day < today;
}
